import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SPECIALS, IMAGES } from "../data/site";

export const Specials = () => {
  return (
    <section
      id="specials"
      data-testid="specials-section"
      className="relative py-24 md:py-32 bg-brand-charcoal text-brand-cream overflow-hidden grain-overlay"
    >
      {/* Top marquee strip */}
      <div className="absolute top-0 left-0 right-0 border-y border-brand-cream/10 py-4 overflow-hidden">
        <div className="flex marquee-track whitespace-nowrap gap-12">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="flex gap-12 shrink-0">
              {["Dum Biryani", "Tandoori Nights", "Hot & Crispy Dosa", "Hyderabadi 65", "Malabar Curry", "Gulab Jamun", "Masala Chai", "Mango Lassi"].map(
                (t, j) => (
                  <span
                    key={`${i}-${j}`}
                    className="font-display uppercase text-2xl md:text-3xl text-brand-cream/40"
                  >
                    {t} <span className="text-brand-red mx-2">✦</span>
                  </span>
                )
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <span className="font-heading uppercase text-[11px] tracking-[0.3em] font-bold text-brand-mustard">
              · Explore the Dishes
            </span>
            <h2 className="mt-3 font-display uppercase text-5xl md:text-6xl lg:text-7xl leading-[0.9]">
              Today's <span className="text-brand-mustard italic">Specials.</span>
            </h2>
          </motion.div>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="max-w-md text-brand-cream/65 leading-relaxed"
          >
            From quick lunch escapes to slow-cooked dinner classics — every special
            is built around what's freshest in the kitchen today.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {SPECIALS.map((s, i) => (
            <motion.a
              href="#menu"
              key={s.title}
              data-testid="special-feature-card"
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              whileHover={{ y: -10 }}
              className="group relative block rounded-3xl overflow-hidden bg-brand-ink border border-white/5 hover:border-brand-mustard/40 transition-colors"
            >
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={IMAGES[s.image]}
                  alt={s.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-1000"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-ink via-brand-ink/40 to-transparent" />
              </div>

              <div className="absolute top-5 left-5 px-3 py-1.5 rounded-full bg-brand-cream/90 backdrop-blur text-brand-charcoal font-heading uppercase text-[10px] tracking-[0.2em] font-bold">
                {s.badge}
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-7">
                <h3 className="font-display uppercase text-3xl md:text-4xl leading-none">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm text-brand-cream/70 leading-relaxed max-w-xs">
                  {s.blurb}
                </p>
                <div className="mt-5 inline-flex items-center gap-2 font-heading uppercase text-[11px] tracking-[0.2em] font-bold text-brand-mustard group-hover:gap-3 transition-all">
                  Explore Dishes
                  <ArrowUpRight size={14} className="group-hover:rotate-12 transition-transform" />
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};
